import { createSlice } from '@reduxjs/toolkit';
import {getBeneficiaryRelationshipTypesAsync} from './actions';

export interface BeneficiaryRelationshipValues {
  label: string,
  value: string
}

export interface BeneficiaryRelationshipState {
  status: 'idle' | 'loading' | 'failed';
  list: Array<BeneficiaryRelationshipValues>;
  errorMessage: string | undefined;
}

const initialState: BeneficiaryRelationshipState = {
  status: 'idle',
  list: [],
  errorMessage: '',
};


export const BeneficiaryRelationshipSlice = createSlice({
  name: 'beneficiaryRelationship',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBeneficiaryRelationshipTypesAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBeneficiaryRelationshipTypesAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.list = [];
        state.errorMessage = action.payload.errorMessage;
      })
      .addCase(getBeneficiaryRelationshipTypesAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.list = action.payload;
        state.errorMessage = ''
      })
  },
});

export default BeneficiaryRelationshipSlice.reducer;
